/*eslint-disable*/
import { useEffect, useState } from 'react';
import { Container, Nav, Navbar, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiFillHeart } from 'react-icons/ai';
import { BsFillBookmarkFill } from 'react-icons/bs';
import { FaList, FaRegUserCircle } from 'react-icons/fa';
import { HiOutlineChevronDown } from 'react-icons/hi';
import { IoNotificationsSharp } from 'react-icons/io5';
import { RxRulerSquare } from 'react-icons/rx';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { areaUnitOptions } from '../../constant/commonData';
import { Logo } from '../../constant/imagePath';
import { convertCurrency } from '../../services/currency-converter';
import { setAreaUnit, setCurrencyUnit } from '../../store/converter/converterSlice';
import { MenuList } from '../AccountInfoLayout';
import Button from '../Button/Button';
import CustomPopover from '../CustomPopover';
import HeaderFavoriteList from '../HeaderFavouriteList';
import HeaderNotification from '../HeaderNotification/HeaderNotification';
import HeaderSaveSearch from '../HeaderSaveSearch';
import Style from './DesktopHeader.module.css';
import HeaderCompareList from './HeaderCompareList';

export const IconWithCount = ({ icon, count }) => {
  return (
    <div className={[Style.iconWithCount, 'c-p'].join(' ')}>
      {!!count && <span>{count > 9 ? `9+` : count}</span>}
      {icon}
    </div>
  );
};

const AccountInfoOverlay = ({ safeNavigate }) => {
  const { t } = useTranslation('webCommon');
  const d = (a) => t(`userSidebarOptions.${[a]}`);

  return (
    <div className={Style.sidebar_main}>
      <MenuList safeNavigate={safeNavigate} d={d} isMobile={false} />
    </div>
  );
};

const DesktopHeader = ({
  logo = Logo,
  backgroundColor,
  className,
  isScroll,
  containerClass,
  onLogout,
  changeLanguage,
  allCurrency,
  safeNavigate,
  t
}) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const navigate = useNavigate();
  const { languages } = useSelector((state) => state.commonReducer);

  const mapLang = languages && languages;
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { areaUnit, currency } = useSelector((state) => state?.converterReducer);
  const { isLogin, user } = useSelector((state) => state?.authReducer);
  const {
    propertyProjectsAndEvents,
    favorite: favoriteData,
    savedSearches,
    compareList
  } = useSelector((state) => state?.notificationReducer);

  const favoriteDataSum =
    (favoriteData?.properties?.length || 0) +
    (favoriteData?.events?.length || 0) +
    (favoriteData?.projects?.length || 0);

  const savedSearchesSum =
    (savedSearches?.properties?.length || 0) +
    (savedSearches?.events?.length || 0) +
    (savedSearches?.projects?.length || 0);

  const compareListSum =
    (compareList?.properties?.length || 0) +
    (compareList?.events?.length || 0) +
    (compareList?.projects?.length || 0);

  const [openNotification, setOpenNotification] = useState(null);
  const [openFavorites, setOpenFavorites] = useState(null);
  const [openCompare, setOpenCompare] = useState(null);
  const [openSaveSearch, setOpenSaveSearch] = useState(null);
  const [openAccount, setOpenAccount] = useState(null);
  const [openLanguages, setOpenLanguages] = useState(null);
  const [openUnits, setOpenUnits] = useState(null);
  const [openCurrency, setOpenCurrency] = useState(null);
  const [loadingCurrency, setLoadingCurrency] = useState(false);

  const onChangeCurrency = async (unit = '', symbol = '') => {
    setOpenCurrency(null);

    if (unit === 'USD') {
      dispatch(setCurrencyUnit({ unit, value: 1, symbol }));
      return;
    }

    let value = null;
    setLoadingCurrency(true);

    try {
      value = await convertCurrency({ unit });

      if (!value) throw new Error('');

      dispatch(setCurrencyUnit({ unit, value, symbol }));
    } catch (error) {
      toast.error('Could not convert currency! Please try after sometime.');
    } finally {
      setLoadingCurrency(false);
    }
  };
  const filteredAreaUnitOptions = areaUnitOptions[selectedLanguage] || areaUnitOptions.en;

  return (
    <Navbar
      collapseOnSelect
      expand="lg"
      className={`${[Style.header, className, isScroll && Style.afterScroll].join(' ')}`}
      style={{ backgroundColor: backgroundColor }}
      id={'navDesktopHeader'}>
      {/* First Header */}
      <div className={Style.firstHead}>
        <Container className={`${Style.flexSpBtw} ${containerClass}`}>
          <ul>
            <CustomPopover
              anchorEl={openLanguages}
              setAnchorEl={setOpenLanguages}
              Component={
                <ul className={[Style?.languagesOptions, 'ltr'].join(' ')}>
                  {mapLang?.map((item, index) => {
                    return (
                      <li
                        key={index}
                        data-selected={selectedLanguage == item?.value}
                        onClick={() => {
                          changeLanguage(item?.value);
                          setOpenLanguages(null);
                        }}>
                        <img src={item?.flag} /> {item?.label}
                      </li>
                    );
                  })}
                </ul>
              }
              className={Style.overlay}
              TriggerComp={() => (
                <li>
                  <Button
                    variant="transparent"
                    rightIcon={<HiOutlineChevronDown size={14} color="var(--white-clr)" />}
                    className="t-t-c">
                    <img
                      className={Style.flag}
                      src={mapLang?.find((item) => item?.value === selectedLanguage)?.flag}
                    />
                  </Button>
                </li>
              )}
              // anchorEl={openNotification}
              // setAnchorEl={setOpenNotification}
            />

            <li>
              {/* <Button
                variant="transparent"
                rightIcon={<HiOutlineChevronDown size={20} color="var(--secondary-clr)" />}>
                {t('webHeader.currency')}
              </Button> */}
              <CustomPopover
                anchorEl={openCurrency}
                setAnchorEl={setOpenCurrency}
                Component={
                  <ul className={[Style?.languagesOptions, 'ltr'].join(' ')}>
                    {allCurrency?.map((item, index) => {
                      const currencyName = item.title[selectedLanguage] || item.title.en; // Use selectedLanguage for localization
                      return (
                        <li
                          key={index}
                          data-selected={currency.unit === item.code}
                          onClick={() => onChangeCurrency(item.code, item.symbol)}>
                          {currencyName} ({item.symbol})
                        </li>
                      );
                    })}
                  </ul>
                }
                className={Style.overlay}
                TriggerComp={() => (
                  <li>
                    <Button
                      className={Style.currencyBtn}
                      variant="transparent"
                      rightIcon={<HiOutlineChevronDown size={14} color="var(--white-clr)" />}>
                      {currency?.symbol}
                      {'  '}
                      {/* {t('webHeader.currency')} */}({currency.unit}){' '}
                      {loadingCurrency && <Spinner animation="border" size="sm" />}
                    </Button>
                  </li>
                )}
              />

              {/* <CustomPopover
                anchorEl={openCurrency}
                setAnchorEl={setOpenCurrency}
                Component={
                  <ul className={[Style?.languagesOptions, 'ltr'].join(' ')}>
                    {allCurrency?.map((item, index) => {
                      return (
                        <li
                          key={index}
                          data-selected={currency.unit == item?.code}
                          onClick={() => onChangeCurrency(item?.code, item?.symbol)}>
                          {item?.title} ({item.symbol})
                        </li>
                      );
                    })}
                  </ul>
                }
                className={Style.overlay}
                TriggerComp={() => (
                  <li>
                    <Button
                      variant="transparent"
                      rightIcon={<HiOutlineChevronDown size={20} color="var(--secondary-clr)" />}>
                      {t('webHeader.currency')} ({currency.unit}){' '}
                      {loadingCurrency && <Spinner animation="border" size="sm" />}
                    </Button>
                  </li>
                )}
              /> */}
            </li>
            <li>
              <CustomPopover
                anchorEl={openUnits}
                setAnchorEl={setOpenUnits}
                Component={
                  <ul className={[Style?.languagesOptions, 'ltr'].join(' ')}>
                    {filteredAreaUnitOptions?.map((item, index) => {
                      return (
                        <li
                          key={index}
                          data-selected={areaUnit == item?.value}
                          onClick={() => {
                            dispatch(setAreaUnit(item?.value));
                            setOpenUnits(null);
                          }}>
                          {item?.label}
                        </li>
                      );
                    })}
                  </ul>
                }
                className={Style.overlay}
                TriggerComp={() => (
                  <li>
                    <Button
                      className={Style.unitBtn}
                      variant="transparent"
                      rightIcon={<HiOutlineChevronDown size={14} color="var(--white-clr)" />}>
                      {/* {t('webHeader.areaUnit')} */}
                      <RxRulerSquare /> {'  '}({areaUnit})
                    </Button>
                  </li>
                )}
              />
            </li>
          </ul>
          <ul className={[Style.headerLinks, 'ltr'].join(' ')}>
            <li>
              <NavLink
                to="/contact-us"
                onClick={(e) => {
                  e.preventDefault();
                  if (safeNavigate) {
                    safeNavigate('/contact-us');
                    return;
                  }
                  window.location.href = '/contact-us';
                }}>
                {' '}
                {t('webFooter.contactUs')}
              </NavLink>
            </li>
            <li>
              <div className={Style.line} />
            </li>
            <li>
              <NavLink
                to="/blog"
                onClick={(e) => {
                  e.preventDefault();
                  if (safeNavigate) {
                    safeNavigate('/blog');
                    return;
                  }
                  window.location.href = '/blog';
                }}>
                {' '}
                {t('webFooter.blog')}
              </NavLink>
            </li>
            <li>
              <div className={Style.line} />
            </li>
            <li>
              <NavLink
                to="/advertise-with-us"
                onClick={(e) => {
                  e.preventDefault();
                  if (safeNavigate) {
                    safeNavigate('/advertise-with-us');
                    return;
                  }
                  window.location.href = '/advertise-with-us';
                }}>
                {' '}
                {t('webFooter.advertiseWithUs')}
              </NavLink>
            </li>
          </ul>
        </Container>
      </div>
      {/* First Header */}
      {/* Second Header */}
      <div className={Style.secondHead}>
        <Container className={`${Style.aCenter} ${containerClass}`}>
          {/* <div onClick={() => navigate('/')} className={Style.logoDiv}>
            <img src={logo} alt="" />
          </div> */}
          <NavLink
            to="/"
            className={Style.logoDiv}
            onClick={(e) => {
              e.preventDefault();
              if (safeNavigate) {
                safeNavigate('/');
                return;
              }
              window.location.href = '/';
            }}>
            <img src={logo} alt="" />
          </NavLink>

          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className={` ${[Style.gapCustm].join(' ')}`}>
              <>
                <NavLink
                  to="/buy"
                  className={({ isActive }) =>
                    `${[Style.nabarLinks, isActive && Style.navActive].join(' ')}`
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (safeNavigate) {
                      safeNavigate('/buy');
                      return;
                    }
                    window.location.href = '/buy';
                  }}>
                  {t('webHeader.buy')}
                </NavLink>
                <NavLink
                  to="/rent"
                  className={({ isActive }) =>
                    `${[Style.nabarLinks, isActive && Style.navActive].join(' ')}`
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (safeNavigate) {
                      safeNavigate('/rent');
                      return;
                    }
                    window.location.href = '/rent';
                  }}>
                  {t('webHeader.rent')}
                </NavLink>
                <NavLink
                  to="/projects"
                  className={({ isActive }) =>
                    `${[Style.nabarLinks, isActive && Style.navActive].join(' ')}`
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (safeNavigate) {
                      safeNavigate('/projects');
                      return;
                    }
                    window.location.href = '/projects';
                  }}>
                  {t('webHeader.projects')}
                </NavLink>
                <NavLink
                  to="/events"
                  className={({ isActive }) =>
                    `${[Style.nabarLinks, isActive && Style.navActive].join(' ')}`
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (safeNavigate) {
                      safeNavigate('/events');
                      return;
                    }
                    window.location.href = '/events';
                  }}>
                  {t('webHeader.events')}
                </NavLink>
                {!['company', 'agent'].includes(user?.role) && (
                  <NavLink
                    to="/property-request"
                    className={({ isActive }) =>
                      `${[Style.nabarLinks, isActive && Style.navActive].join(' ')}`
                    }
                    onClick={(e) => {
                      e.preventDefault();
                      if (safeNavigate) {
                        safeNavigate('/property-request');
                        return;
                      }
                      window.location.href = '/property-request';
                    }}>
                    {t('webHeader.propertyRequest')}
                  </NavLink>
                )}
                {/* <NavLink
                  to="/property-request"
                  className={({ isActive }) =>
                    `${[Style.nabarLinks, isActive && Style.navActive].join(' ')}`
                  }>
                  Property Request
                </NavLink> */}

                <NavLink
                  to="/agents"
                  className={({ isActive }) =>
                    `${[Style.nabarLinks, isActive && Style.navActive].join(' ')}`
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (safeNavigate) {
                      safeNavigate('/agents');
                      return;
                    }
                    window.location.href = '/agents';
                  }}>
                  {t('webHeader.agents')}
                </NavLink>
                <div className={Style.divider}></div>
                {isLogin && (
                  <>
                    <ul className={Style.headerIcons}>
                      <CustomPopover
                        Component={<HeaderNotification t={t} />}
                        className={Style.overlay}
                        TriggerComp={() => (
                          <li>
                            <IconWithCount
                              icon={<IoNotificationsSharp color="var(--primary-clr)" size={24} />}
                              count={propertyProjectsAndEvents?.length}
                            />
                          </li>
                        )}
                        anchorEl={openNotification}
                        setAnchorEl={setOpenNotification}
                      />
                      {user?.role == 'user' && (
                        <>
                          {/* Favorite List */}
                          <CustomPopover
                            Component={<HeaderFavoriteList t={t} />}
                            className={Style.overlay}
                            TriggerComp={() => (
                              <li>
                                <IconWithCount
                                  icon={<AiFillHeart color="var(--primary-clr)" size={24} />}
                                  count={favoriteDataSum}
                                />
                              </li>
                            )}
                            anchorEl={openFavorites}
                            setAnchorEl={setOpenFavorites}
                          />
                          {/* Save Searches */}
                          <CustomPopover
                            Component={<HeaderSaveSearch t={t} />}
                            className={Style.overlay}
                            TriggerComp={() => (
                              <li>
                                <IconWithCount
                                  icon={<BsFillBookmarkFill color="var(--primary-clr)" size={20} />}
                                  count={savedSearchesSum}
                                />
                              </li>
                            )}
                            anchorEl={openSaveSearch}
                            setAnchorEl={setOpenSaveSearch}
                          />

                          {/* Compare List */}
                          <CustomPopover
                            Component={<HeaderCompareList t={t} />}
                            className={Style.overlay}
                            anchorEl={openCompare}
                            setAnchorEl={setOpenCompare}
                            TriggerComp={() => (
                              <li>
                                <IconWithCount
                                  icon={
                                    <FaList color="var(--primary-clr)" size={20} />
                                    // <img
                                    //   src={compare_icon}
                                    //   draggable={false}
                                    //   width={20}
                                    //   height={'auto'}
                                    // />
                                  }
                                  count={compareListSum}
                                />
                              </li>
                            )}
                          />
                        </>
                      )}
                      {/* My Account Overlay */}
                      <CustomPopover
                        Component={<AccountInfoOverlay safeNavigate={safeNavigate} />}
                        className={Style.overlay}
                        anchorEl={openAccount}
                        setAnchorEl={setOpenAccount}
                        TriggerComp={() => (
                          <li>
                            <Button
                              variant="transparent"
                              className={[Style.loginBtn, Style.userAccBtn].join(' ')}
                              leftIcon={<FaRegUserCircle color="var(--primary-clr)" size={22} />}
                              onClick={() => {}}>
                              {t('webHeader.myAccountPopup.title')}
                            </Button>
                          </li>
                        )}
                      />
                    </ul>
                  </>
                )}
                {!isLogin && (
                  <NavLink to="/login" className={[Style.nabarLinks, 'c-p', Style.login].join(' ')}>
                    <Button
                      variant="transparent"
                      className={Style.loginBtn}
                      leftIcon={<FaRegUserCircle size={24} color="var(--primary-clr)" />}>
                      {t('webHeader.login')}
                    </Button>
                  </NavLink>
                )}
              </>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </div>
      {/* Second Header */}
    </Navbar>
  );
};

export default DesktopHeader;
